var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { autoinject, transient } from "aurelia-framework";
var TicketSalesValueConverter = /** @class */ (function () {
    function TicketSalesValueConverter() {
    }
    TicketSalesValueConverter.prototype.toView = function (item) {
        if (item) {
            return item * -1;
        }
        return 0;
    };
    TicketSalesValueConverter.prototype.fromView = function (item) {
        if (item) {
            return item * -1;
        }
        return 0;
    };
    TicketSalesValueConverter = __decorate([
        autoinject,
        transient()
    ], TicketSalesValueConverter);
    return TicketSalesValueConverter;
}());
export { TicketSalesValueConverter };
